

export default {
  install: function (Vue) {
    Vue.prototype.$globalData = {
      serverUrl: process.env.VUE_APP_SERVER_URL || 'http://182.92.73.6',
      userInfo: '',
      imgFile: 'http://101.43.105.130:9002/prod-api'
    };
    Vue.prototype.$getUserInfo = function () {
      try {
        let obj = localStorage.getItem('userInfo')
        obj = JSON.parse(obj)
        return obj || {}
      } catch (e) {
        return {}
      }
    }
    Vue.prototype.$setUserInfo = function (obj) {
      try {
        obj && localStorage.setItem('userInfo', JSON.stringify(obj))
      } catch (e) { }
    }
    Vue.prototype.$isLogIn = function() {
      const res = this.$getUserInfo()
      return !! (res && res.userName || false)
    }
    Vue.prototype.$goLogIn = function() {
      this.$router.push({
        path: '/logIn'
      })

    }
    
    Vue.prototype.floatAdd = function (arg1, arg2) {
      return (Math.round(arg1 * 100) + Math.round(arg2 * 100)) / 100;
    };
    Vue.prototype.floatAdd = function (arg1, arg2) {
      return (Math.round(arg1 * 100) + Math.round(arg2 * 100)) / 100;
    };
    Vue.prototype.pollingWeChat = function (type, order_no, fn) {
      clearInterval(window.weChatPay);
      window.weChatPay = setInterval(() => {
        this.$http.post('paycheck', {
          type: type,
          order_no: order_no,
        }).then(
          (res) => {
            if (res.data.code === 200) {
              if (res.data.data.trade_status) {
                clearInterval(window.weChatPay);
                fn && fn();
              }
            }
          }
        )
      }, 2000);
    };

    Vue.prototype.countUp = function (dom, end, start, duration) {
      dom = dom && document.querySelector(dom);
      if (!dom || !end) {
        return;
      }
      dom.style.display = "inline-block";
      dom.style.transformOrigin = "center bottom";
      dom.style.transition = "all 20ms linear";
      start = start ? start >= end ? 0 : start : 0;
      duration = duration || 1000;
      var interval = dom, length = end - start, precision = length >= 10 ? 0 : 2, indicator = 0, gap = 0,
        tempVal = 0, flag = false;
      interval.innerHTML = "" + (precision === 0 ? start : (precision === 2 ? start.toFixed(2) : start));
      window.__countUp && clearInterval(window.__countUp);
      window.__countUp = setInterval(function () {
        if (indicator >= duration) {
          clearInterval(window.__countUp);
          delete window.__countUp;
          tempVal = "" + (precision === 0 ? end : (precision === 2 ? end.toFixed(2) : end));
          if (interval.innerHTML !== tempVal) {
            interval.innerHTML = tempVal;
          }
          dom.style.transform = "none";
        } else {
          indicator += 20;
          gap = length * (indicator <= duration * 0.5 ? 0.7 : 0.3) / (duration * 0.5) * 20;
          start = +start + gap;
          start = start > end ? end : start;
          tempVal = "" +
            (precision === 0 ?
              (Math.floor(start) > end ? end : Math.round(start))
              : (precision === 2 ? (Math.floor(start * 100) / 100) : start));
          if (interval.innerHTML !== tempVal) {
            interval.innerHTML = tempVal;
            dom.style.transform = flag ? "scale(0.9)" : "scale(1)";
            flag = !flag;
          }
        }
      }, 20);
    };
    /**
     * 跳转到首页方法
     */
    Vue.prototype.goPage = function (str) {
      if (str === 'logIn') {
        window.sessionStorage.setItem('canReturn', window.location.href);
      }
      if (str === '/') {
        this.$router.push({  //核心语句
          path: '/',   //跳转的路径
        })
        return
      }
      this.$router.push({  //核心语句
        path: '/' + str,   //跳转的路径
      })
    };
    Vue.prototype.getPercent = function (num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0%" : (Math.round(num / total * 10000) / 100.00) + "%";
    }
    /**
     * 吐司
     * @param msg
     * @param time
     */
    Vue.prototype.showToastBtm = function (msg, time) {
      if (!window.x_toast) {
        let toastDom = document.createElement("div");
        let styleText = "position: fixed; z-index: 19; top: 50%; -webkit-transform: translateY(-50%); transform: translateY(-50%);  left: 50%; -webkit-transform: translateX(-50%); transform: translateX(-50%);  max-width: 700px; margin: auto; " +
          "padding: 30px 60px; border-radius: 8px; background: rgba(0,0,0,.6); " +
          "line-height: 1.4; text-align: center; letter-spacing: 1px; font-size: 24px; color: #fff;";
        toastDom.innerHTML = msg;
        toastDom.style.cssText = styleText;
        document.body.appendChild(toastDom);
        window.x_toast = setTimeout(function () {
          document.body.removeChild(toastDom);
          delete window.x_toast;
        }, +time ? time : 2000);
      }
    };
    /**
     * 日期格式
     */
    Vue.prototype.timeFormat = function (time) {
      var date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

      return Y + M + D + h + m;
    }
  }
}
